import { render, staticRenderFns } from "./StepsLayout.vue?vue&type=template&id=4affc3d8&scoped=true&"
import script from "./StepsLayout.vue?vue&type=script&lang=js&"
export * from "./StepsLayout.vue?vue&type=script&lang=js&"
import style0 from "./StepsLayout.vue?vue&type=style&index=0&id=4affc3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4affc3d8",
  null
  
)

export default component.exports